












































import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { CruiseTeamData, emptyCruiseTeam, getInfo, putData, postData } from '@/api/cruiseTeam/index'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    // ItemCode: [{ required: true, message: '请输入编码', trigger: 'change' }],
    ItemValue: [{ required: true, message: '请输入巡防组织名称', trigger: 'blur' }],
    // SubSequence: [{ required: true, validator: validateIntKey('请输入排序'), trigger: 'blur' }]
  }
}

@Component({
  components: {
    FormDialog
  }
})
export default class CruiseTeamModify extends Vue {
  public name = 'CruiseTeamModify'
  public expandNames = ['info']

  public form = Object.assign({}, emptyCruiseTeam)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
  }
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  // 打开事件
  public openEvent: string = 'openCruiseTeamModify'
  // 提交事件
  public submitEvent: string = 'submitCruiseTeamModify'
  public showDialog: boolean = false
  public loading: boolean = false

  public created() { }

  public mounted() {
    //接收数据，父页面使用 window.eventBus.$emit() 发送数据
    window.eventBus.$on(this.openEvent,
      (id: number) => {
        this.open()
        this.fetchData(id)
      }
    )
  }
  public beforeDestroy() {
    //销毁事件，避免重复注册
    window.eventBus.$off(this.openEvent)
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.$refs.formData.resetFields()
    this.showDialog = false
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public callBack(f: CruiseTeamData) {
    window.eventBus.$emit(this.submitEvent, f)
  }
  public fetchSource() {
  }
  public fetchData(id: number) {
    this.loading = true
    getInfo(id).then((response: { data: any }) => {
      this.form = response.data
      // this.rules = getFormRules(this.form)
      if (this.form.Id == 0) {
        this.$refs.formData.resetFields()
        this.$refs.formData.clearValidate()
      }
      this.loading = false
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const promist =
          this.form.Id > 0
            ? putData(this.form.Id, this.form)
            : postData(this.form)
        promist.then(
          (response: { data: any }) => {
            let f = Object.assign({}, this.form)
            const data = response.data
            const msg = f.Id > 0 ? '保存' : '创建'
            if (data && !data.IsError) {
              this.$message({
                message: `${msg}成功`,
                type: 'success'
              })
              if (f.Id == 0) {
                f.Id = +data.Message
              }
              this.close()
              this.callBack(f)
            } else {
              this.$message({
                dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
              })
              console.log('提交失败', data)
            }
          },
          (data: any) => {
            console.log(data)
          }
        )
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
